module.exports = __webpack_public_path__ + "img/base_activites_cinema.11fa8a3c.svg";